import { ReferenceDataConstants } from '../../../constants/reference-data-constants';
import { ReferenceData } from '../../reference-data.model';

export class KendoGridSort {
  public field: string;
  public dir: string;

  public initFromRefDataSort(refData: ReferenceData): KendoGridSort {
    this.field = refData.getAttributeValue(ReferenceDataConstants.FIELD_ATTRIBUTE_NAME);
    this.dir = refData.getAttributeValue(ReferenceDataConstants.DIRECTION_ATTRIBUTE_NAME);

    return this;
  }
}
